import React from 'react'
import ReactDOM from 'react-dom'
import 'babel-polyfill'
import App from '~/pages/App'
import registerServiceWorker from '~/registerServiceWorker'
import { initZhihuHybrid } from '~/utils'
import './raven'
import './index.css'

const docEl = document.documentElement
const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
const reCalc = function() {
  const cWidth = docEl.clientWidth
  if (!cWidth) return
  let fontSize = 200 * (cWidth / 750)
  // 如果是pc访问
  if (!/windows phone|iphone|android/gi.test(window.navigator.userAgent)) {
    fontSize = 100
  }
  docEl.style.fontSize = `${fontSize}px`
}
window.addEventListener(resizeEvt, reCalc, false)
document.addEventListener('DOMContentLoaded', reCalc, false)

initZhihuHybrid()

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js